export default "__VITE_ASSET__CA2jkK39__"